export const configuracaoItems = {
  category: "configuracoes",
  key: "configuracoes",
  name: "Configurações",
};
